import { yupResolver } from "@hookform/resolvers/yup";
import { FormGroup } from "@itandi/itandi-bb-ui/FormGroup";
import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useSettlementItems } from "~/hooks/useSettlementItems";
import type { NskResponse } from "~/models/Api";
import type { DealSettlementEdit } from "~/models/DealSettlement";
import {
	buildDefaultSettlement,
	validationSchemaSettlement
} from "~/models/DealSettlement";
import { isSuccess } from "~/utils/api/api_handler";
import { SettlementForm } from "../SettlementForm";
import { SettlementFormFooter } from "../SettlementFormFooter";

type Props = {
	billingType: "owner" | "rentee";
	handleCreate: (submitValue: DealSettlementEdit) => Promise<NskResponse>;
	mutateConstructions: () => Promise<void>;
};
export const SettlementAddForm: React.FC<Props> = ({
	billingType,
	handleCreate,
	mutateConstructions
}: Props) => {
	const { data: settlementItems } = useSettlementItems().index();
	const methods = useForm<DealSettlementEdit>({
		defaultValues: buildDefaultSettlement(billingType),
		mode: "onBlur",
		resolver: yupResolver(validationSchemaSettlement)
	});
	const onClickSubmit = React.useCallback(() => {
		methods.handleSubmit(async () => {
			const response = await handleCreate(methods.getValues());
			if (isSuccess(response)) {
				await mutateConstructions();
				methods.reset();
				toast.success("追加しました");
				return;
			}
			toast.error("エラーが発生しました");
			methods.reset();
		})();
	}, [handleCreate, methods, mutateConstructions]);
	if (settlementItems === null) return null;
	return (
		<FormProvider {...methods}>
			<FormGroup variant="vertical">
				<SettlementForm settlementItems={settlementItems} />
			</FormGroup>
			<SettlementFormFooter onClickSubmit={onClickSubmit} type="add" />
		</FormProvider>
	);
};
